/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OtaAccommodationMetrics } from '../models/OtaAccommodationMetrics';
import type { OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_read } from '../models/OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_read';
import type { OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_write } from '../models/OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OtaAccommodationMetricsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a OtaAccommodationMetrics resource.
     * Retrieves a OtaAccommodationMetrics resource.
     * @param accommodationId OtaAccommodationMetrics identifier
     * @returns OtaAccommodationMetrics OtaAccommodationMetrics resource
     * @throws ApiError
     */
    public apiAccommodationslistingmixmetricsotaAccommodationIdGet(
        accommodationId: string,
    ): CancelablePromise<OtaAccommodationMetrics> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/mix/metrics/ota/{accommodationId}',
            path: {
                accommodationId: accommodationId,
            },
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * Updates the OtaAccommodationMetrics resource.
     * Updates the OtaAccommodationMetrics resource.
     * @param listingType OtaAccommodationMetrics identifier
     * @param listingId OtaAccommodationMetrics identifier
     * @param accommodationId OtaAccommodationMetrics identifier
     * @param requestBody The updated OtaAccommodationMetrics resource
     * @returns OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_read OtaAccommodationMetrics resource updated
     * @throws ApiError
     */
    public apiAccommodationslistingsmetricsotaListingTypeListingIdAccommodationIdPatch(
        listingType: string,
        listingId: string,
        accommodationId: string,
        requestBody: OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_write,
    ): CancelablePromise<OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_metrics_read> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/accommodations/listings/metrics/ota/{listingType}/{listingId}/{accommodationId}',
            path: {
                listingType: listingType,
                listingId: listingId,
                accommodationId: accommodationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                404: `Resource not found`,
                422: `Unprocessable entity`,
            },
        });
    }
}
